module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "teacher-verification"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "content-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "真实姓名",
      "prop": "realname",
      "error": _vm.errors.first('realname')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.realname),
      callback: function($$v) {
        _vm.form.realname = $$v
      },
      expression: "form.realname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属省份",
      "prop": "province",
      "error": _vm.errors.first('province')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.clearErrors('province')
      }
    },
    model: {
      value: (_vm.form.province),
      callback: function($$v) {
        _vm.form.province = $$v
      },
      expression: "form.province"
    }
  }, _vm._l((_vm.provinces), function(prov) {
    return _c('el-option', {
      key: prov.code,
      attrs: {
        "label": prov.name,
        "value": prov.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "任教学校",
      "prop": "organization",
      "error": _vm.errors.first('organization')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.organization),
      callback: function($$v) {
        _vm.form.organization = $$v
      },
      expression: "form.organization"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "证件图片",
      "prop": "certificate",
      "error": _vm.errors.first('certificate')
    }
  }, [_c('ssuploader', {
    ref: "uploader",
    attrs: {
      "url": _vm.uploadUrl,
      "accept": _vm.accept,
      "extensions": _vm.extensions,
      "name": "verification[certificate]",
      "data": _vm.uploadData,
      "autoSubmit": false
    },
    on: {
      "change": _vm.preview,
      "complete": _vm.complete,
      "error": _vm.error
    }
  }, [_c('div', {
    ref: "uploader-btn",
    staticClass: "preview-wrapper",
    class: {
      'shrink': !_vm.form.certificate
    }
  }, [(_vm.supportPreview && _vm.form.certificate) ? _c('img', {
    ref: "preview-image",
    staticClass: "img",
    attrs: {
      "alt": _vm.form.filename
    }
  }) : (!_vm.supportPreview && _vm.form.certificate) ? _c('div', [_c('p', [_vm._v("文件名：" + _vm._s(_vm.form.filename))]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("您的浏览器暂不支持预览图片")])]) : _c('div', {
    staticClass: "img default"
  })])])], 1), _vm._v(" "), _c('el-form-item', [_c('p', {
    staticClass: "hint"
  }, [_vm._v("请上传本人教师资格证件，确保照片清晰，四角完整")])]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('el-form-item', [_c('p', {
    staticClass: "hint",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("注意：通过教师认证后，请务必只上传教学相关的内容。如果擅自用于商业用途，一经发现，平台将取消优惠资格，按正常价格核算额度。")])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-header"
  }, [_c('p', [_c('em', [_vm._v("教师认证")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content-hint"
  }, [_c('i', {
    staticClass: "ppj-icon-gift"
  }), _vm._v("PP匠推出教育发展计划，公立学校老师可以199元购买价值999元的教育专业版（包含50个永久项目额度），助力教育信息化")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6756e1a9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/teacher_verification.vue
// module id = 929
// module chunks = 3